<template>
  <div class="card border-0 m-3" style="width: 18rem;">
    <a v-if="imageLink" :href="imageLink" class="" target="_blank">
      <img class="card-img-top custom-img w-100"
           :src="imageSrc"
           :alt="imageAlt"
           style="max-height: 170px; width: auto; object-fit: cover;">
    </a>
    <img v-else class="card-img-top custom-img"
         :src="imageSrc"
         :alt="imageAlt"
         style="max-height: 140px; width: auto; object-fit: contain;">

    <div class="card-body pb-1 pl-1 pr-1">
      <h5 class="card-title">{{ titleDefault }}</h5>
      <p class="card-text">{{ bodyDefault }}</p>
    </div>

    <div class="card-footer bg-transparent border-0 pl-0 pr-0 text-primary" v-if="videoLink">
      <div class="w-100">
        <button class="btn btn-outline-primary custom-btn-outline" @click="handleAction">
          {{ $tr('getStarted.full.guide.no1', 'See our full guide') }}
          <font-awesome-icon class="ml-1" icon="arrow-right"></font-awesome-icon>
        </button>
      </div>
      <font-awesome-icon :icon="['far', 'rocket']"/>
      <button class="d-inline-flex mt-2 mr-3 align-items-center text-primary font-weight-bold border-0 bg-transparent"
              @click="onPrimaryClick">
        {{ $tr('getStarted.quick.guide', 'Quick guide') }}
      </button>
      <font-awesome-icon v-if="manualLink" :icon="['far', 'file-lines']"/>
      <button v-if="manualLink" class="d-inline-flex mt-2 align-items-center text-primary font-weight-bold border-0 bg-transparent"
              @click="showManual">
        {{ $tr('getStarted.pdf.manual', 'PDF Manual') }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.custom-img {
  border-radius: 10px;
  filter: drop-shadow(2px 2px 10px rgba(0, 0, 0, 0.15));
  transition: transform 0.3s ease-in-out, filter 0.3s ease-in-out;
}

.custom-img:hover {
  transform: scale(1.05);
  filter: drop-shadow(4px 4px 15px rgba(0, 0, 0, 0.3));
  cursor: pointer;
}


.card-footer {
  min-height: 50px;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.custom-btn-outline {
  font-weight: bold;
  border-width: 1px;
  border-radius: 8px;
}
</style>

<script>
import ActivityManager from "@/activity/ActivityManager";

export default {
  name: "GuideCard",
  props: {
    imageSrc: String,
    imageAlt: String,
    imageLink: String,
    titleDefault: String,
    bodyDefault: String,
    onPrimaryClick: Function,
    manualLink: String,
    videos: Array,
    videoLink: String
  },
  methods: {
    handleAction() {
      ActivityManager.showActivity(require("@/components/dashboard/GuidesActivity.vue"), {
        videoGuides: this.videos,
        title: this.titleDefault
      });
    },
    showManual() {
      window.open(this.manualLink, '_blank');
    }
  }
};
</script>
